// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultRoom_container__1VZ3E","label":"DefaultRoom_label__1Hc-R","actions":"DefaultRoom_actions__2zFIP"};